import React from 'react';
import { cn } from '../../lib/utils';

/**
 * OrkaText — semantic text wrapper (PRD §7.2).
 * Replaces ad-hoc `<p className="text-slate-XXX">` spread across the codebase.
 *
 * Variants follow the text-token map:
 *   primary | secondary | tertiary | disabled | inverse
 *   success | warning | danger | info | intent
 *
 * Sizes follow the H1/H2/Body/Small hierarchy from system guidelines.
 */
const SIZE_CLASSES = {
  h1: 'text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight',
  h2: 'text-base md:text-lg font-semibold',
  h3: 'text-sm md:text-base font-semibold',
  body: 'text-sm md:text-base',
  small: 'text-xs',
  micro: 'text-[10px] uppercase tracking-wider font-semibold',
  mono: 'font-mono text-xs tabular-nums',
};

const VARIANT_CLASSES = {
  primary: 'orka-text-primary',
  secondary: 'orka-text-secondary',
  tertiary: 'orka-text-tertiary',
  disabled: 'orka-text-disabled',
  inverse: 'orka-text-inverse',
  success: 'orka-text-success',
  warning: 'orka-text-warning',
  danger: 'orka-text-danger',
  info: 'orka-text-info',
  intent: 'orka-text-intent',
};

export function OrkaText({
  as: Tag = 'span',
  size = 'body',
  variant = 'primary',
  truncate = false,
  className,
  children,
  ...rest
}) {
  return (
    <Tag
      className={cn(
        SIZE_CLASSES[size] || SIZE_CLASSES.body,
        VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary,
        truncate && 'truncate',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default OrkaText;
